import { AbstractControl, ValidationErrors } from "@angular/forms";

export const matchValues = (
	matchTo: string // name of the control to match to
): ((AbstractControl) => ValidationErrors | null) => {
	return (control: AbstractControl): ValidationErrors | null => {
		return !!control?.parent?.value && control?.value?.toLowerCase() === control?.parent?.controls[matchTo]?.value?.toLowerCase()
			? null
			: {
					confirmEmailInvalid: {
						valid: false,
						message: "Email address is not the same"
					}
					// tslint:disable-next-line: indent
			  };
	};
};
